import { motion } from 'framer-motion';
import { map } from 'lodash';
import { motionFadeIn } from 'utils';

const AboutUs = () => {
  const informations = [
    {
      icon: 'bg-[url("/icons/about-us/note-search-outline.svg")]',
      title: 'Thủ tục nhanh chóng',
      content:
        'Cán bộ công nhân viên làm việc liên tục nhằm phục vụ khách hàng tốt nhất và tiết kiệm thời gian khách hàng nhất.',
    },
    {
      icon: 'bg-[url("/icons/about-us/flash-outline.svg")]',
      title: 'Tư vấn tận tình',
      content:
        'Với phương châm “Khách hàng là thượng đế”, Phòng Công chứng sẽ mang đến cho khách hàng những thông tin tư vấn nhanh chóng, chính xác và đúng pháp luật.',
    },
    {
      icon: 'bg-[url("/icons/about-us/clock-time-two-outline.svg")]',
      title: 'Tiết kiệm thời gian',
      content:
        'Đội ngũ Công chứng viên, thư ký nghiệp vụ với kinh nghiệm nhiều năm công tác, đặt thời gian của khách hàng lên trên hết.',
    },
    {
      icon: 'bg-[url("/icons/about-us/checkbox-multiple-marked-circle-outline.svg")]',
      title: 'Chính xác',
      content:
        'Đặt an toàn pháp lý cho khách hàng lên hàng đầu, Phòng sẽ cung cấp những văn bản đúng pháp luật với sự chính xác cao.',
    },
    {
      icon: 'bg-[url("/icons/about-us/home-edit-outline.svg")]',
      title: 'Công chứng hồ sơ tại nhà',
      content:
        'Cung cấp dịch vụ ngoài ngày, giờ làm việc của cơ quan hành chính nhà nước để đáp ứng nhu cầu công chứng của khách hàng theo quy định tạii điều 32, luật Công chứng 2015.',
    },
    {
      icon: 'bg-[url("/icons/about-us/cash-check.svg")]',
      title: 'Chi phí phù hợp',
      content:
        'Chi phí hợp lý của phòng công chứng phản ánh giá trị dịch vụ, đảm bảo sự minh bạch và phê duyệt tài liệu, bảo vệ khỏi rủi ro pháp lý, hỗ trợ trong giao dịch thành công và đáng tin cậy.',
    },
  ];
  return (
    <section
      id='about-us'
      className='container mx-auto my-[40px] min-w-[1052px] space-y-[40px] px-[48px]'
    >
      <h2 className='mb-[40px] text-[24px] font-[600] leading-[29px] text-service-text'>
        Về chúng tôi
      </h2>
      <ul className='-my-[20px] -mx-[12px] flex flex-wrap'>
        {map(informations, (information, informationIndex) => (
          <motion.li
            variants={motionFadeIn('right', 'tween', informationIndex * 0.1, 0.5)}
            initial='hidden'
            whileInView='show'
            key={informationIndex}
            viewport={{ once: true }}
            className='flex w-1/3 space-x-[24px] px-[12px] py-[20px]'
          >
            <div
              className={`${information.icon} max-h-[48px] min-h-[48px] min-w-[48px] max-w-[48px] bg-cover bg-center`}
            />
            <div className='flex flex-1 flex-col space-y-[24px]'>
              <span className='text-[18px] font-[600] leading-[22px] text-service-text'>
                {information.title}
              </span>
              <span className='text-justify leading-[20px]'>{information.content}</span>
            </div>
          </motion.li>
        ))}
      </ul>
    </section>
  );
};

export default AboutUs;
